import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { CarpaService } from './carpa.service';
import { IDocumentDownloadOtt } from '@core-lib/models';

@Injectable({
	providedIn: 'root'
})
export class RibService {
	get tenantKey() {
		return this.carpaService.currentCarpa.tenantKey;
	}

	get carpaId() {
		return this.carpaService.currentCarpa.id;
	}

	constructor(
		private http: HttpClient,
		private carpaService: CarpaService
	) {}

	getRibPdfOtt(affaireId?: string): Observable<IDocumentDownloadOtt> {
		return this.http.get<IDocumentDownloadOtt>(`${environment.apiUrl}/t/${this.tenantKey}/rib/${affaireId}/pdf/ott`);
	}

	getRibPdfUrl(ott: string): string {
		return `${environment.apiUrl}/t/${this.tenantKey}/rib/pdf/${ott}`;
	}
}
